/**
 * Payroll value lists (SRS §12.5) shared by the `payroll` schema, the API and the web app.
 * Values are UPPER_SNAKE.
 */
/** Run types (FR-PAY-5): one MONTHLY run per period; BONUS / LTA in any month; exits. */
export const PAY_RUN_TYPES = ['MONTHLY', 'BONUS', 'LTA', 'SETTLEMENT'];
/** Run workflow (FR-PAY-12): DRAFT → SUBMITTED → APPROVED → DISBURSED; CANCELLED from DRAFT. */
export const PAY_RUN_STATUSES = [
    'DRAFT',
    'SUBMITTED',
    'APPROVED',
    'DISBURSED',
    'CANCELLED',
];
/** The part of a line an item is paid from or taken out of (FR-PAY-8/9). */
export const PAY_PARTS = ['CASH', 'BANK'];
/** Where a run line item's amount came from. */
export const PAY_ITEM_SOURCES = ['SALARY', 'STANDING', 'MANUAL', 'PROVIDER', 'COMPUTED'];
/** Per-employee run inputs (FR-PAY-2…4, FR-PAY-13, FR-PAY-20). */
export const PAY_RUN_INPUTS = [
    'LWP_DAYS',
    'ADVANCE',
    'FOOD',
    'AIT',
    'PF',
    'BONUS',
    'LTA',
    'ARREAR',
    'SPECIAL_AMOUNT',
];
/** Where a run input's value came from; MANUAL overrides win on recalculation (BR-PAY-4). */
export const PAY_INPUT_SOURCES = ['PROVIDER', 'STANDING', 'MANUAL'];
/** Disbursement channels (FR-PAY-17). */
export const DISBURSEMENT_CHANNELS = ['BANK', 'CASH'];
/**
 * Bank upload files that need configuration (ADR-073): City Bank's multiple-payment upload for
 * transfers to City Bank accounts. BEFTN (other banks) is not built.
 */
export const BANK_UPLOAD_FORMATS = ['CITY_BANK'];
/** Bank advice files Finance can download (FR-PAY-17): the generic list and the uploads. */
export const BANK_ADVICE_FORMATS = ['GENERIC', ...BANK_UPLOAD_FORMATS];
export const BANK_ADVICE_FORMAT_LABELS = {
    GENERIC: 'Bank advice (list)',
    CITY_BANK: 'City Bank upload',
};
//# sourceMappingURL=enums.js.map